module.exports = __webpack_public_path__ + "img/sink-unit-var-02.edaec099.png";